<template>
  <!-- modelConfiguration   模型配置-->
  <el-card class="tabs-card" v-loading="loading">
    <el-tabs class="tabs-box" v-model="activeName" tab-position="left">
      <el-tab-pane label="疑似涉赌窝点出现人次阈值" name="one">
        疑似涉赌窝点出现人次阈值
        <el-input-number
          v-model="tableParams.wodian"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <div style="margin-left: 150px; margin-top: 50px">
          <h-button type="primary" @click="wodianClick()">保存</h-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="疑似涉毒窝点出现人次阈值" name="sar">
        疑似涉毒窝点出现人次阈值
        <el-input-number
          v-model="tableParams.du"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <div style="margin-left: 150px; margin-top: 50px">
          <h-button type="primary" @click="duClick()">保存</h-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="疑似传销窝点出现人次阈值" name="sasr">
        疑似传销窝点出现人次阈值
        <el-input-number
          v-model="tableParams.cx"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <div style="margin-left: 150px; margin-top: 50px">
          <h-button type="primary" @click="cxClick()">保存</h-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="疑似离开规则" name="sassr">
        疑似离开规则
        <el-input-number
          v-model="tableParams.lk"
          :min="0"
          :max="500"
          controls-position="right"
        />
        <div style="margin-left: 150px; margin-top: 50px">
          <h-button type="primary" @click="lkClick()">保存</h-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="疑似房屋单月用气阈值" name="two">
        <modelGroup></modelGroup>
      </el-tab-pane>
      <el-tab-pane label="区域安全实况系数" name="xs">
        <xsDetail></xsDetail>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import modelTheOld from "./components/modelTheOld.vue";
import xsDetail from "./components/xsDetail.vue";
import modelGroup from "./components/modelGroup.vue";
import { dictUpdate, getDict } from "@/api/constant.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "",
  components: { modelTheOld, modelGroup, xsDetail },
  props: {},
  setup(props) {
    const data = reactive({
      tableParams: { wodian: 1, du: 1, cx: 1, lk: 1 },
      loading: false
    });
    const refData = toRefs(data);
    const activeName = ref("one");
    const wodianClick = async () => {
      data.loading = true;
      const res = await getDict("gamble_num_threshold");
      const params = res.dict[0];
      params.value = data.tableParams.wodian;
      await dictUpdate(params);
      data.loading = false;
      ElMessage({
        type: "success",
        message: "修改成功"
      });
    };
    const duClick = async () => {
      data.loading = true;
      const res = await getDict("drug_num_threshold");
      const params = res.dict[0];
      params.value = data.tableParams.du;
      await dictUpdate(params);
      data.loading = false;
      ElMessage({
        type: "success",
        message: "修改成功"
      });
    };
    const cxClick = async () => {
      data.loading = true;
      const res = await getDict("sell_num_threshold");
      const params = res.dict[0];
      params.value = data.tableParams.cx;
      await dictUpdate(params);
      data.loading = false;
      ElMessage({
        type: "success",
        message: "修改成功"
      });
    };
    const lkClick = async () => {
      data.loading = true;
      const res = await getDict("maybe_leave_rule");
      const params = res.dict[0];
      params.value = data.tableParams.lk;
      await dictUpdate(params);
      data.loading = false;
      ElMessage({
        type: "success",
        message: "修改成功"
      });
    };

    return {
      ...refData,
      lkClick,
      wodianClick,
      cxClick,
      duClick,
      activeName
    };
  }
});
</script>
<style lang="scss" scoped></style>
